import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

type Variant = "info" | "success" | "warning" | "danger";

const VARIANT: Record<
  Variant,
  { border: string; bg: string; iconColor: string; title: string; body: string }
> = {
  info: {
    border: "border-indigo-100",
    bg: "bg-indigo-50",
    iconColor: "text-indigo-600",
    title: "text-indigo-900",
    body: "text-indigo-700",
  },
  success: {
    border: "border-emerald-100",
    bg: "bg-emerald-50",
    iconColor: "text-emerald-600",
    title: "text-emerald-900",
    body: "text-emerald-700",
  },
  warning: {
    border: "border-amber-100",
    bg: "bg-amber-50",
    iconColor: "text-amber-600",
    title: "text-amber-900",
    body: "text-amber-700",
  },
  danger: {
    border: "border-rose-100",
    bg: "bg-rose-50",
    iconColor: "text-rose-600",
    title: "text-rose-900",
    body: "text-rose-700",
  },
};

interface InfoBannerProps {
  icon: LucideIcon;
  title: string;
  description: string;
  variant?: Variant;
  className?: string;
}

export function InfoBanner({
  icon: Icon,
  title,
  description,
  variant = "info",
  className,
}: InfoBannerProps) {
  const s = VARIANT[variant];
  return (
    <div
      className={cn("flex items-center gap-4 rounded-2xl border p-5", s.border, s.bg, className)}
    >
      <Icon size={22} className={s.iconColor} />
      <div>
        <p className={cn("text-xs font-black uppercase tracking-widest", s.title)}>{title}</p>
        <p className={cn("mt-1 text-[11px] font-medium leading-relaxed", s.body)}>{description}</p>
      </div>
    </div>
  );
}
